import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import styles from "./../../assets/style/otp-input.module.scss";
import { useMemo } from "react";
// regular expression
export const RE_DIGIT = new RegExp(/^\d+$/);
export const OtpInput = ({ value, valueLength, onChange, customStyles, inputRef, }) => {
    const dommyRef = useRef(null);
    const valueItems = useMemo(() => {
        const valueArray = value.split("");
        const items = [];
        for (let i = 0; i < valueLength; i++) {
            const char = valueArray[i];
            if (RE_DIGIT.test(char)) {
                items.push(char);
            }
            else {
                items.push("");
            }
        }
        return items;
    }, [value, valueLength]);
    // -------focus on next input-box---------
    const focusToNextInput = (target) => {
        // target next otp-input if exist
        const nextElementSibling = target.nextElementSibling;
        // focus on next otp-input if exist
        if (nextElementSibling) {
            nextElementSibling.focus();
        }
    };
    // -------focus on previous input-box---------
    const focusToPrevInput = (target) => {
        // target prev otp-input if exist
        const previousElementSibling = target.previousElementSibling;
        // focus on prev otp-input if exist
        if (previousElementSibling) {
            previousElementSibling.focus();
        }
    };
    // -------change the value of otp-input------------
    const inputOnChange = (e, idx) => {
        const target = e.target;
        // get the value of entered in otp-input
        let targetValue = target.value.trim();
        // check if the value is digit or not
        const isTargetValueDigit = RE_DIGIT.test(targetValue);
        if (!isTargetValueDigit && targetValue !== "") {
            return;
        }
        // target next otp-input if exist
        const nextInputEl = target.nextElementSibling;
        // only delete digit if next input element has no value
        if (!isTargetValueDigit && nextInputEl && nextInputEl.value !== "") {
            return;
        }
        targetValue = isTargetValueDigit ? targetValue : " ";
        // get length of value
        const targetValueLength = targetValue.length;
        if (targetValueLength === 1) {
            const newValue = value.substring(0, idx) + targetValue + value.substring(idx + 1);
            onChange(newValue, idx);
            if (!isTargetValueDigit) {
                return;
            }
            focusToNextInput(target);
        }
        else if (targetValueLength === valueLength) {
            onChange(targetValue, idx);
            target.blur();
        }
    };
    // ----------delete digit from input-box and focus back to the prev input-box---------------
    const inputOnKeyDown = (e) => {
        const { key } = e;
        const target = e.target;
        // control arrow keys
        if (key === "ArrowRight" || key === "ArrowDown") {
            e.preventDefault();
            return focusToNextInput(target);
        }
        if (key === "ArrowLeft" || key === "ArrowUp") {
            e.preventDefault();
            return focusToPrevInput(target);
        }
        // get the value of entered in otp-input
        let targetValue = target.value;
        // keep the selection range position if the same digit was typed
        target.setSelectionRange(0, targetValue.length);
        if ((key !== "Backspace" && key !== "Enter") || target.value !== "") {
            return;
        }
        focusToPrevInput(target);
    };
    const inputOnFocus = (e) => {
        const { target } = e;
        // keep focusing back until previous input element has value
        const prevInputEl = target.previousElementSibling;
        if (prevInputEl && prevInputEl.value === "") {
            return prevInputEl.focus();
        }
        target.setSelectionRange(0, target.value.length);
    };
    return (_jsx("div", Object.assign({ className: styles["_group"] }, { children: valueItems.map((digits, idx) => (_jsx("input", { ref: idx === 0 ? inputRef : dommyRef, type: "text", inputMode: "numeric", pattern: "\\d{1}", maxLength: valueLength, className: styles["_otp-input"], value: digits, autoComplete: "one-time-code", onChange: (e) => inputOnChange(e, idx), onKeyDown: inputOnKeyDown, autoFocus: idx === 0 ? true : false, onFocus: inputOnFocus }, idx))) })));
};
